import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useContext,
} from "react"
import PropTypes from "prop-types"
import gsap from "gsap"
import { Link, navigate } from "gatsby"
import { Transition } from "react-transition-group"

import ReferralContext from "../../contexts/ReferralContext"
// import WindowContext from "../../contexts/WindowContext"

import { lockScroll, unlockScroll } from "../../helpers/functions"
import TextField from "../ui/input/textField/TextField"
import Checkbox from "../ui/input/checkbox/Checkbox"
import Button from "../ui/button/Button"
import Container from "../../hoc/container/Container"

import FIELDS from "../../resources/FormFields"
import style from "./RegistrationForm.module.css"

import closeIcon from "../../assets/icons/close-grey.svg"

const RegistrationForm = props => {
  const { show, closePressed } = props
  const form = useRef()
  const [inputData, setInputData] = useState({})
  const [invalidFields, setInvalidFields] = useState({})
  const [validFields, setValidFields] = useState({})

  // This ID is appended to the share link
  const { referrerId, userReferralId } = useContext(ReferralContext)

  useEffect(() => {
    console.log(referrerId, userReferralId)
  })

  useEffect(() => {
    document.addEventListener("keypress", handleKeypress)
    return () => {
      document.removeEventListener("keypress", handleKeypress)
    }
  }, [])

  useEffect(() => {
    if (show) {
      lockScroll()
    } else {
      unlockScroll()
    }
  }, [show])

  const handleKeypress = e => {
    let keynum = e.keyCode || e.which
    if (keynum === 13) {
      submitForm()
    }
  }

  const submitForm = async e => {
    e.preventDefault()

    // Custom field validation
    let valid = true
    let invalidFields = {}

    FIELDS.forEach(field => {
      if (field.required) {
        // console.log('field required');
        if (
          inputData[field.name] === undefined ||
          inputData[field.name] === "" ||
          inputData[field.name] === false
        ) {
          // console.log('field not entered', field.name);
          valid = false
          invalidFields[field.name] = true
        }
      }
    })
    // Check GDPR Marketing permissions
    if (!inputData["gdpr[25161]"]) {
      valid = false
      invalidFields["gdpr[25161]"] = true
    }
    setInvalidFields(invalidFields)

    if (!valid) return

    // Created form data in x-www-form-urlencoded format.
    const formData = new URLSearchParams([...new FormData(form.current)])

    for (var value of formData.values()) {
      console.log(value)
    }

    console.log("formData", formData)
    // Submit Form Data manually (so that Mailchimp doesn't redirect us)
    const response = await fetch(
      "https://app.us8.list-manage.com/subscribe/post?u=f6845ce33706a4020fc04ffab&amp;id=e59f0e1ccd",
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "omit", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: formData, // body data type must match "Content-Type" header
      }
    )
      .then(response => {
        console.log(response)
        setInputData({})
        navigate(`/success?referral=${userReferralId}`)
      })
      .catch(error => {
        console.log(error)
      })
  }

  const updateField = useCallback(e => {
    e.persist()
    setInputData(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }, [])

  const validateInput = useCallback(
    e => {
      e.persist()
      // TODO: smarter validation
      let valid = true
      if (!e.target.value.length < 3) valid = false
      setValidFields({ ...validFields, [e.target.name]: valid })
    },
    [inputData, validFields]
  )

  const updateCheckbox = useCallback((e, key) => {
    e.preventDefault()
    setInputData(prev => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const rowStyle = {
    width: "100%",
  }

  const inputElements = FIELDS.map(field => {
    switch (field.type) {
      default:
        return (
          <div className="animatingField" style={rowStyle} key={field.name}>
            <TextField
              name={field.name}
              type={field.type}
              emoji={field.emoji}
              // TODO: Check these
              value={inputData[field.name] || ""}
              placeholder={field.placeholder}
              onChange={updateField}
              onBlur={validateInput}
              valid={validFields[field.name]}
              invalid={invalidFields[field.name]}
              halfWidth={field.halfWidth}
              customClass={style.field}
              disabled={false}
            />
          </div>
        )

      // case "checkbox":
      //   return (
      //     <div
      //       className={[style.formRow, "animatingField"].join(" ")}
      //       key={field.name}
      //       style={rowStyle}
      //     >
      //       {/* <Link href={field.href}> */}
      //       <label>{field.label}</label>
      //       {/* </Link> */}
      //       <Checkbox
      //         checked={inputData[field.name]}
      //         pressed={e => updateCheckbox(e, field.name)}
      //         invalid={invalidFields[field.name]}
      //         disabled={false}
      //       />
      //     </div>
      //   )

      case "bot":
        return (
          <input
            key="bot"
            id="bot"
            type="text"
            name="b07"
            tabIndex="-1"
            value=""
            hidden={true}
          />
        )
    }
  })

  const onEnter = useCallback(node => {
    // Set the fields down and out
    gsap.set(".animatingField", { y: 60, autoAlpha: 0 })
  }, [])

  const transition = useCallback(
    (node, done) => {
      if (show) {
        // Transition In
        gsap.to(".animatingField", {
          duration: 0.3,
          y: 0,
          autoAlpha: 1,
          stagger: 0.08,
          onComplete: () => done(),
        })
      } else {
        // Transition Out
        gsap.to(".animatingField", {
          duration: 0.2,
          autoAlpha: 0,
        })
        gsap.to(node, {
          duration: 0.2,
          delay: 0.1,
          autoAlpha: 0,
          onComplete: () => done(),
        })
      }
    },
    [show]
  )

  return (
    <Transition
      mountOnEnter={true}
      unmountOnExit={true}
      in={show}
      onEnter={node => onEnter(node)}
      addEndListener={(node, done) => transition(node, done)}
    >
      <div className={style.container}>
        <img
          src={closeIcon}
          className={style.close}
          title="Close form"
          alt="close"
          onClick={closePressed}
        />

        <Container>
          <h1 className="animatingField">Request Early Access</h1>
          <form
            ref={form}
            id="subscribeForm"
            name="subscribe"
            className={style.form}
            noValidate={true}
          >
            <input
              type="text"
              name="REFERRAL"
              hidden={true}
              readOnly={true}
              tabIndex="-2"
              value={userReferralId}
            />
            <input
              type="text"
              name="REFERREDBY"
              hidden={true}
              tabIndex="-1"
              readOnly={true}
              value={referrerId}
            />
            {inputElements}
            {/* TODO: Map the GDPR fields */}
            <div className={[style.permissions, "animatingField"].join(" ")}>
              <p>Please select the ways you would like to hear from Fufil:</p>
              {/* <label for="gdpr_25157"> */}
              <div className={style.formRow}>
                <Checkbox
                  label="Email *"
                  name="gdpr[25161]"
                  checked={inputData["gdpr[25161]"]}
                  pressed={e => updateCheckbox(e, "gdpr[25161]")}
                  invalid={invalidFields["gdpr[25161]"]}
                />
                <Checkbox
                  label="Text Message"
                  name="gdpr[25157]"
                  checked={inputData["gdpr[25157]"]}
                  pressed={e => updateCheckbox(e, "gdpr[25157]")}
                  invalid={invalidFields["gdpr[25157]"]}
                />
              </div>

              <p>
                You can unsubscribe at any time by clicking the link in our
                emails. For information see our{" "}
                <Link to="/legal" target="_blank">
                  privacy policy.
                </Link>
              </p>
            </div>
            <div className="animatingField">
              <Button contained={true} label="SIGN UP" pressed={submitForm} />
            </div>
          </form>
        </Container>
      </div>
    </Transition>
  )
}

RegistrationForm.propTypes = {
  closePressed: PropTypes.func.isRequired,
}

export default RegistrationForm

// const handleNewFormData = e => {
//   // e.persist()
//   console.log("new form data created", e.formData)
//   // Get the form data from the event object
//   const data = e.formData
//   for (var value of data.values()) {
//     console.log(value)
//   }
// }

// <!-- Begin Mailchimp Signup Form -->
// <div id="mc_embed_signup">
// <form action="https://app.us8.list-manage.com/subscribe/post?u=f6845ce33706a4020fc04ffab&amp;id=e59f0e1ccd" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
//     <div id="mc_embed_signup_scroll">

// <div class="mc-field-group">
// 	<label for="mce-EMAIL">Email Address </label>
// 	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
// </div>
// <div class="mc-field-group">
// 	<label for="mce-FNAME">First Name </label>
// 	<input type="text" value="" name="FNAME" class="" id="mce-FNAME">
// </div>
// <div class="mc-field-group size1of2">
// 	<label for="mce-PHONE">Phone Number </label>
// 	<input type="text" name="PHONE" class="" value="" id="mce-PHONE">
// </div>
// <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
//     <div class="content__gdpr">
//         <label>Communication Permissions</label>
//         <p>Please select all the ways you would like to hear from Fufil:</p>
//         <fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
// 		<label class="checkbox subfield" for="gdpr_25157"><input type="checkbox" id="gdpr_25157" name="gdpr[25157]" value="Y" class="av-checkbox gdpr"><span>Telephone</span> </label><label class="checkbox subfield" for="gdpr_25161"><input type="checkbox" id="gdpr_25161" name="gdpr[25161]" value="Y" class="av-checkbox gdpr"><span>Email</span> </label>
//         </fieldset>
//         <p>You can unsubscribe at any time by clicking the link in the footer of our emails. For information see our privacy policy.</p>
//     </div>
//     <div class="content__gdprLegal">
//         <p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/" target="_blank">Learn more about Mailchimp's privacy practices here.</a></p>
//     </div>
// </div>
// 	<div id="mce-responses" class="clear">
// 		<div class="response" id="mce-error-response" style="display:none"></div>
// 		<div class="response" id="mce-success-response" style="display:none"></div>
// 	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
//     <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_f6845ce33706a4020fc04ffab_e59f0e1ccd" tabindex="-1" value=""></div>
//     <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
//     </div>
// </form>
// </div>

// <!--End mc_embed_signup--></div>
